import { render, staticRenderFns } from "./ListTableRightClickMenu.vue?vue&type=template&id=0747a484&scoped=true&"
import script from "./ListTableRightClickMenu.vue?vue&type=script&lang=js&"
export * from "./ListTableRightClickMenu.vue?vue&type=script&lang=js&"
import style0 from "./ListTableRightClickMenu.vue?vue&type=style&index=0&id=0747a484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747a484",
  null
  
)

export default component.exports